import React from 'react';
import { Alert, Checkbox, Divider } from 'antd';
import ReactMarkdown from 'react-markdown';

import defaultStyles from './style.less';

function QuestionMultiChoice({ question,
                               answer,
                               disabled,
                               mutating,
                               onSetAnswer,
                               showValidationMessage,
                               styles = { step: defaultStyles.step,
                                         desc: defaultStyles.desc,
                                         checkboxCorrect: defaultStyles.checkboxCorrect,
                                         checkboxIncorrect: defaultStyles.checkboxIncorrect,
                                         checkboxWrapper: defaultStyles.checkboxWrapper
                                       }
                             }) {
  if (!question)
    return null;

  const onChangeMulti = (e) => {
    const options = e.map(val => {
      const [index, option] = val.split('|');
      return {
        index,
        value: '', //not used
        correct: option === '1'
      };
    });
    if (onSetAnswer) onSetAnswer(options);
  };

  const { task, comment } = question;

  const answerValues = answer && answer.answerElements ? answer.answerElements.filter(o => !!o).map(o => o.correct ? `${o.index}|1` : `${o.index}|0`) : [];

  return (
    <div className={styles.step}>
      <div className={styles.desc}>
        <Checkbox.Group onChange={onChangeMulti} value={answerValues}>
          <ReactMarkdown
            key={question.slug}
            source={task}
            renderers={{
              listItem: props => {
                //checked checkbox
                const isCorrect = props.checked === true;
                //unchecked checkbox
                const isIncorrect = props.checked === false; //!strict comparison, simple list item has checked = null

                //just some list item in the wild
                if (!(isCorrect || isIncorrect))
                  return <li>{props.children}</li>;

                const value = `${props.index}|${isCorrect ? '1' : '0'}`;
                const isSet = answerValues.some(v => v === value);
                const selectClass = disabled ? ( (isCorrect && isSet) || (!isCorrect && !isSet) ? styles.checkboxCorrect : styles.checkboxIncorrect) : '';
                return (
                  <div className={styles.checkboxWrapper}>
                    <Checkbox value={value} className={selectClass} disabled={disabled || mutating} >
                      {props.children}
                    </Checkbox>
                  </div>
                );
              },
              paragraph:'div',
            }}
          />
        </Checkbox.Group>

				{ showValidationMessage ? <Alert type="error" message="You must choose the answer" /> : null }
				{ disabled && (
						<>
							<Divider />
							<ReactMarkdown source={comment} />
						</>
					)
				}
			</div>
    </div>
  );
}

export default QuestionMultiChoice;
